module.exports = __webpack_public_path__ + "media/images/flags/64/Taiwan-1ae32189db09f21770299f160b956e9d.png";